import {type GetSettingsServiceOrderVariantsApiResponse} from '../types';

const getServiceOrderVariantsSettingsResponseMock: GetSettingsServiceOrderVariantsApiResponse = [
  {
    id: 'service-order-variant-id',
    isActive: true,
    name: 'Warranty',
    authorizationProfileId: 'authorization-profile-id',
    serviceCaseTypeId: 'service-case-type-id',
    isDefaultForServiceCaseType: true,
    serviceOrderTypeId: 'service-order-type-id',
    isUnitPriceWithVat: false,
    priceType: 'PURCHASE_PRICE',
    priceTypeRatio: 1,
    rateType: 'SVCRATETYPE_INT',
    rateTypeRatio: 1,
    isChangeableDefaultCustomer: false,
    isCancelReasonRequired: false,
  },
];

const getServiceOrderVariantReportingResponseMock = {
  defaultServiceOrderGroupId: 'group-1',
  isDefaultServiceOrderGroupLocked: false,
  excludedServiceOrderGroupIds: [],
  isPreDeliveryInspection: false,
  isDbiReportBodyshop: false,
};

const getServiceOrderVariantAccountingResponseMock = {
  defaultServiceCenterId: 'centre-1',
  isDefaultServiceCenterLocked: false,
  excludedServiceCenterIds: [],
  fixedVatType: null,
  isTaxDeductible: false,
};

export const metadaWorkshopServiceOrderVariantApiMock = {
  getServiceOrderVariantsSettingsResponseMock,
  getServiceOrderVariantReportingResponseMock,
  getServiceOrderVariantAccountingResponseMock,
};
